import { TripActions, TripActionTypes, TripState } from '../../types/trip.store.type';
import { StorageKeys } from '../../types/keys.type';
import { SharedUtils } from '../../utils';

const initialState: TripState = {
    isLoading: false,
    isCancelled: false,
    error: null,
    shouldCleanCache: false,
    shouldShowEarlyCheckOut: false,
    isPoolHeatAvailable: null,
};

export function tripReducer(state = initialState, action: TripActionTypes): TripState {
    switch (action.type) {
        case TripActions.FETCH_FROM_ZERO: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }

        case TripActions.FETCH_BEGIN: {
            if (state.reservation) {
                return state;
            }

            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }

        case TripActions.FETCH_SUCCESS: {
            const {
                reservation_id,
                reservation,
                stay,
                unit,
                required_actions,
                access,
                home_info,
                guests,
                unit_amenities,
                departure,
                idv_status,
                idv_url,
                review,
            } = action.payload;

            const trip: { [key: string]: any } = {
                id: reservation_id,
                confirmation_code: SharedUtils.getSessionStorageItem(StorageKeys.CONFIRMATION_CODE),
                reservation,
                stay,
                unit,
                required_actions,
                access,
                home_info,
                guests,
                unit_amenities,
                departure,
                review,
            };

            trip.idv = { status: idv_status, url: idv_url };

            return {
                ...state,
                ...trip,
                isLoading: false,
                error: null,
            };
        }

        case TripActions.FETCH_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        }

        case TripActions.SET_IS_POOL_HEAT_AVAILABLE: {
            return { ...state, isPoolHeatAvailable: action.payload };
        }

        case TripActions.EDIT_GUESTS_SUCCESS: {
            return { ...state, guests: action.payload };
        }

        case TripActions.EDIT_GUESTS_ERROR: {
            return { ...state, error: action.payload };
        }

        case TripActions.SET_CLEAN_CACHE_FLAG: {
            return { ...state, shouldCleanCache: action.payload };
        }

        case TripActions.SET_EARLY_CHECKOUT_FLAG: {
            return { ...state, shouldShowEarlyCheckOut: action.payload };
        }

        case TripActions.SET_RESERVATION_IS_CANCELLED: {
            return { ...state, isCancelled: action.payload };
        }

        case TripActions.SET_RESERVATION_TRIP_PROTECTION_INFO: {
            return {
                ...state,
                tripProtectionMessage: action.payload.trip_protection_message,
            };
        }

        default: {
            return state;
        }
    }
}
